import React from 'react';
import { motion } from 'framer-motion';
import { InteriorSlide, SlideTitle } from './SlideShell';
import type { SlideProps } from './SlideShell';
import { SnakStill } from '../SnakStill';
import { broaderSignals, teaserSignals } from '../../data/snakkerStory';
export function SlideSignals({}: SlideProps) {
  return <InteriorSlide data-id="element-542" data-mp="1y78ozpb0vud2">
      <SlideTitle eyebrow="Every interaction creates a signal" data-id="element-543" data-mp="1y7quzdnhlmy6">
        Engagement is useful. <span className="text-[var(--brand)]" data-id="element-544" data-mp="234hc84b12ol6">What it tells us can be even more useful.</span>
      </SlideTitle>

      <div className="mt-[clamp(1rem,2vw,1.75rem)] flex min-h-0 flex-1 gap-[clamp(1.25rem,3vw,3rem)]" data-id="element-545" data-mp="282she1qdoax2">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.15,
        duration: 0.5
      }} className="hidden w-[15%] flex-shrink-0 flex-col md:flex" data-id="element-546" data-mp="2cvvfmn63o8jl">
          <SnakStill screen={2} alt="The REKOVELLE Snak mini-simulator — where AMH and weight are explored" className="w-full flex-1" data-id="element-547" data-mp="2quleo8chcial" />
          <p className="mt-2 text-center font-mono text-[clamp(0.55rem,0.7vw,0.66rem)] uppercase tracking-[0.16em] text-[var(--muted)]" data-id="element-548" data-mp="2cjb8800hukst">REKOVELLE teaser</p>
        </motion.div>

        <div className="flex min-h-0 min-w-0 flex-1 flex-col" data-id="element-549" data-mp="23h1w55pkujdb">
          <p className="flex-shrink-0 text-[clamp(0.6rem,0.8vw,0.74rem)] font-bold uppercase tracking-[0.2em] text-[var(--fg)]" data-id="element-550" data-mp="23jeng9h86631">In the REKOVELLE Snak</p>
          <ol className="mt-2 flex min-h-0 flex-1 flex-col border-b border-[var(--fg)]/10" data-id="element-551" data-mp="2v7oi8girqctu">
            {teaserSignals.map((s, i) => <motion.li key={s.question} initial={{
            opacity: 0,
            x: -12
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.25 + i * 0.06,
            duration: 0.4
          }} className="flex min-h-0 flex-1 items-center gap-[clamp(0.75rem,1.4vw,1.25rem)] border-t border-[var(--fg)]/10" data-id="element-552" data-mp="2r98x6i68zej2" data-mpi={i}>
                <span className="relative flex h-2.5 w-2.5 flex-shrink-0 items-center justify-center" data-id="element-553" data-mp="3a58ixb8mtlu7">
                  <span className="absolute h-full w-full rounded-full bg-[var(--brand)]/25" data-id="element-554" data-mp="3t3k53fyyyzf8" />
                  <span className="h-1.5 w-1.5 rounded-full bg-[var(--brand)]" data-id="element-555" data-mp="1umqn3ke0oxr" />
                </span>
                <span className="min-w-0 flex-1 text-[clamp(0.85rem,1.3vw,1.2rem)] font-semibold tracking-[-0.01em] text-[var(--fg)]" data-id="element-556" data-mp="3k95lx2bbj4qu">{s.question}</span>
                <span className="flex-shrink-0 font-mono text-[clamp(0.55rem,0.72vw,0.68rem)] uppercase tracking-[0.16em] text-[var(--muted)]" data-id="element-557" data-mp="3ac10x5t7lfbm">{s.screen}</span>
              </motion.li>)}
          </ol>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.55,
        duration: 0.5
      }} className="hidden w-[24%] flex-shrink-0 flex-col rounded-2xl bg-[var(--surface)] p-[clamp(1rem,1.8vw,1.5rem)] lg:flex" data-id="element-558" data-mp="31c4ivn1brepj">
          <p className="text-[clamp(0.6rem,0.8vw,0.74rem)] font-bold uppercase tracking-[0.2em] text-[var(--fg)]" data-id="element-559" data-mp="13ll0bmx5idk9">Other Snaks could capture</p>
          <ul className="mt-[clamp(0.75rem,1.4vw,1.2rem)] flex flex-wrap gap-1.5" data-id="element-560" data-mp="2o19f1or1y47y">
            {broaderSignals.map(s => <li key={s} className="rounded-full bg-white px-3 py-1.5 text-[clamp(0.72rem,0.95vw,0.9rem)] font-semibold text-[var(--fg)] ring-1 ring-[var(--fg)]/[0.06]" data-id="element-561" data-mp="2xsvmda09rj5f">
                {s}
              </li>)}
          </ul>
        </motion.div>
      </div>

      <motion.p initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.85,
      duration: 0.55
    }} className="mt-[clamp(1rem,2vw,1.75rem)] flex-shrink-0 text-[clamp(2rem,4.6vw,4.4rem)] font-extrabold leading-none tracking-[-0.055em] text-[var(--fg)]" data-id="element-562" data-mp="32sru9kc37uq9">
        Every interaction creates a <span className="text-[var(--brand)]" data-id="element-563" data-mp="1me8lrj9het1n">signal.</span>
      </motion.p>
    </InteriorSlide>;
}